import Jsona, { SwitchCaseJsonMapper } from 'jsona'
import { irwin } from 'config'
import { httpClient } from './httpClient'
import { cancellableQuery } from './utils'
import { snakeCase } from 'change-case-object'

const deserializerAndCase = new Jsona({
  jsonPropertiesMapper: new SwitchCaseJsonMapper({ switchChar: '_' }),
})

function client() {
  return httpClient(irwin.baseUrl)
}

async function searchSurveysAdmin(params) {
  return cancellableQuery(searchSurveysAdminQuery, snakeCase(params))
}

const searchSurveysAdminQuery = async (params, signal) => {
  const response = await client().get('/v2/feedback/surveys/admin_search', {
    params,
    signal,
  })

  return { data: deserializerAndCase.deserialize(response) }
}

const getSurvey = async id => {
  const response = await client().get(`/v2/feedback/surveys/${id}/admin_show`)
  return {
    data: deserializerAndCase.deserialize(response),
  }
}

export { searchSurveysAdmin, getSurvey }
